<div #dropdownWrapper class="dropdown w-100 position-relative">
  <div class="input-group">
    <input #searchInput
           type="text"
           class="form-control autocomplete-input"
           [(ngModel)]="searchText"
           (input)="onSearchChange()" 
           placeholder="Select Caremember" 
           [disabled]="isDropdownDisabled" />
    <!-- Clear (X) button -->
    <span *ngIf="searchText && searchText !== 'Any'"
          class="input-group-text cursor-pointer"
          (click)="clearSelection()">
      ✕
    </span>

    <span class="input-group-text dropdown-toggle" 
          (click)="focusInput()"  
          [class.disabled]="isDropdownDisabled"></span>
  </div>

  <!-- Dropdown -->
  <div *ngIf="dropdownOpen && filteredStates.length"
       class="dropdown-menu show w-100 mt-0 shadow-sm"
       style="max-height: 250px; overflow-y: auto;">

    <!-- Default "Any" option -->
    <button type="button"
            class="dropdown-item"
            (click)="selectState(null)">
      Any
    </button>

    <button *ngFor="let staff of filteredStates"
            type="button"
            class="dropdown-item"
            (click)="selectState(staff)">
      {{ staff.name }} - {{ staff.emailId }}
    </button>
  </div>
</div>
